import React from 'react'
import PropTypes from 'prop-types'

import { Menu as MenuIcon, Close as CloseIcon } from 'components/Icons'
import Button from 'components/Button'
import { Container } from './styles'
import { useUser } from 'context/user-context'

import theme from 'styles/theme'

const MenuButton = ({ color, width, height, variant, handleClick, ...props }) => {
  const { user } = useUser()
  return (
    <Container {...props}>
      <Button size='smallest' variant='ghost' onClick={handleClick}>
        {variant === 'menu' ? (
          <MenuIcon color={color} width={width} height={height} />
        ) : (
          <CloseIcon color={color} width={width} height={height} />
        )}
      </Button>
    </Container>
  )
}

MenuButton.defaultProps = {
  color: theme?.colors?.white,
  width: '20px',
  height: '20px',
  variant: 'menu',
}

MenuButton.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  variant: PropTypes.oneOf(['menu', 'close']),
  handleClick: PropTypes.func,
}

export default MenuButton
